module.exports = __webpack_public_path__ + "static/media/sooncard.ca8cd341.png";